import React, { isValidElement } from "react";
import PropTypes from "prop-types";
import { useStateMachine } from "little-state-machine";
import { useLocation, useNavigate } from "react-router-dom";
import { map } from "react-itertools";
import { updateStore, getDefaultValueFromState } from "../lib/store";
import { getStepFromPath, nextStepFromPath } from "../lib/form/step";
import { useForm } from "react-hook-form";
import qs from "qs";
import getPrefilled from "../lib/form/prefilled";
import parseJSON from "date-fns/parseJSON";
import isValid from 'date-fns/isValid';
import format from 'date-fns/format'

const query = qs.parse(window.location.search.substring(1));
const prefilled = getPrefilled();

function Form({ children, onSubmit }) {
  const methods = useForm({ mode: "onChange", reValidateMode: "onChange" });
  const { handleSubmit } = methods;
  const { actions, state } = useStateMachine({ updateStore });

  const navigate = useNavigate();
  const location = useLocation();

  const activeStep = getStepFromPath(location.pathname);
  const statusSteps = state.statusSteps;

  const onError = (errors, e) => console.log(errors, e);

  const onSubmitWrapper = async (data, e) => {
    const allDatas = {
      ...state.data,
      ...data,
    };

    const allQueries = {
      ...state.query,
      ...query,
    };

    if (
      Object.values(allDatas).filter((value) => value === "__exit").length > 0
    ) {
      return navigate("/exit");
    }
    statusSteps[activeStep] = true;

    actions.updateStore({
      ...state,
      data: allDatas,
      statusSteps,
      query: allQueries,
    });

    const nextPage = nextStepFromPath(location.pathname, statusSteps);
    if (nextPage === "/result") {
      await fetch(
        process.env.NODE_ENV === "production"
          ? "https://n8n.timeonegroup.com/webhook/b064942f-fdff-49b6-a14c-033d7a068a86"
          : "https://n8n.timeonegroup.com/webhook-test/b064942f-fdff-49b6-a14c-033d7a068a86",
        {
          method: "POST",
          mode: "no-cors",
          body: JSON.stringify(
            {
              data: allDatas,
              query: allQueries,
            },
            (key, value) => {
              const testDate = parseJSON(value);
              if (isValid(testDate)) {
                return format(testDate, "yyyy-MM-dd HH:mm:ss");
              }

              return value;
            }
          ),
        }
      );
    }

    onSubmit(allDatas);

    navigate(nextPage);
  };

  const submitter = handleSubmit(onSubmitWrapper, onError);

  const mapChild = (child) => {
    return isValidElement(child) && child.props.name
      ? React.createElement(child.type, {
          ...{
            ...child.props,
            methods,
            key: child.props.name,
            defaultValue: getDefaultValueFromState(
              child.props.name,
              prefilled[child.props.name] ?? child.props.defaultValue,
              state
            ),
          },
        })
      : child;
  };

  return (
    <form onSubmit={submitter} noValidate>
      {map(children, mapChild)}
    </form>
  );
}

Form.defaultProps = {
  onSubmit: (data) => {},
};

Form.propTypes = {
  onSubmit: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
};

export default Form;
